import { defineTabs } from '@/features/admin/shared/tabs';

/**
 * Onglets du détail d'une connexion. L'onglet actif vit dans l'URL (`?tab=`), et l'objet exploré
 * aussi (`?object=`) : une capture ou un lien pointe sur une table, un dossier, un fichier.
 */
export const CONNECTION_TABS = defineTabs(['summary', 'test', 'explore', 'definition'] as const);
export type ConnectionTab = (typeof CONNECTION_TABS.ids)[number];
